import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import ModuleList from '../../../layout/ModuleList';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { ITINERARY_COUNTER_REPORT_COLUMNS } from '../../../../config/columns';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  NEW_ITINERARY_COUNTER_REPORT_PATH,
  ITINERARY_COUNTER_REPORT_PATH,
} from '../../../../config/paths';
import { getItineraryCounterReports } from '../../../../actions';

const ItineraryCounterReports = ({
  breadcrumbs,
  itineraryCounterReports,
  loading,
  dispatchGetItineraryCounterReports,
}) => {
  const data = itineraryCounterReports.get('content') || [];
  const pages = itineraryCounterReports.get('totalPages') || null;
  const defaultPageSize =
    itineraryCounterReports.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Reportes de Itinerarios"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_ITINERARY_COUNTER_REPORT_PATH}
      tableStructure={{
        columns: ITINERARY_COUNTER_REPORT_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: false,
        fetchData: dispatchGetItineraryCounterReports,
        modelPath: ITINERARY_COUNTER_REPORT_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetItineraryCounterReports: getItineraryCounterReports,
};

ItineraryCounterReports.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  itineraryCounterReports: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetItineraryCounterReports: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Reportes de Itinerarios',
      href: ITINERARY_COUNTER_REPORT_PATH,
    },
  ],
  itineraryCounterReports: ItineraryUnit.ItineraryCounterReport.getIn([
    'all',
    'content',
  ]),
  loading: ItineraryUnit.ItineraryCounterReport.getIn(['all', 'loading']),
});

ItineraryCounterReports.defaultProps = {
  itineraryCounterReports: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItineraryCounterReports);
